module.exports = __webpack_public_path__ + "img/link-arrow.6f7f9d13.svg";